module.exports = __webpack_public_path__ + "static/media/no-poster-available.e7d69c9b.jpg";